import React from 'react';
import './DigiSavvyFooter.css'; // Keep the CSS file

// Import icons from react-icons
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube } from 'react-icons/fa';

const DigiSavvyFooter = () => {
  return (
    <footer className="digisavvy-footer-container">
      {/* Hindi Quote Section */}
      <div className="footer-quote-banner">
        <p className="hindi-quote">
          दिमाग में विचार और थाली में अचार... अपना होना चाहिए
        </p>
      </div>

      {/* Optional: Top decorative border */}
      <div className="footer-top-border"></div>

      <div className="footer-main-content">
        <div className="footer-top-row">
          {/* Logo Area */}
          <div className="footer-logo">
            <img src='https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707473680/Digisavvy/Other%20Brands%20LOGOS/w3xfqn5kjshb3hapo3ds.png' alt='DigiSavvy Logo' />
          </div>

          {/* Navigation and Social Links Area */}
          <div className="footer-nav-social">
            <nav className="footer-nav">
              <a href="/">Home</a>
              <a href="/Service">Services</a>
              <a href="/blog">Blog</a>
              <a href="/contact">Contact</a>
              <a href="/cleints">cleints</a>

            </nav>
            <div className="footer-social">
              <a href="https://www.facebook.com/profile.php?id=61552677833279" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebookF />
              </a>
              <a href="https://instagram.com/digisavvyy?igshid=MzRlODBiNWFlZA==" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FaInstagram />
              </a>
              <a href="https://www.linkedin.com/company/digi-savvy/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FaLinkedinIn />
              </a>
              <a href="https://www.youtube.com/@DIGISAVVYy/about" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <FaYoutube />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Copyright Row */}
      <div className="footer-bottom-row">
        <p className="copyright-text">Copyright © {new Date().getFullYear()} DigiSavvy</p> {/* Dynamic year */}
      </div>
    </footer>
  );
};

export default DigiSavvyFooter;